export default __webpack_public_path__ + "static/media/T680_CoC.225d07a1.pdf";